/// SocialBar
import React from 'react';
import config from '../config';
import { Button } from 'semantic-ui-react';
import '../style/App.css';

class SocialBar extends React.Component{
    render(){
        return(
            <div>
                {config.website.footer.social.map(s => (
                    <Button style={Style.button} circular color={s.id} icon={s.id} onClick={(e)=>{ window.open(s.link, '_blank')}}>
                        {s.text}
                    </Button>
                ))}
            </div>
        )
    }
};

const Style = {
    button: {
        margin: '20px',        
        fontSize: '14px',
        fontWeight: '400',
    }
}
export default SocialBar;


// WEBPACK FOOTER //
// ./src/components/SocialBar.js